import { ThunkAction, ThunkDispatch } from "redux-thunk";
import {
    FETCH_CITAS_REQUEST,
    FETCH_CITAS_SUCCESS,
    FETCH_CITAS_FAILURE,
    CREATE_CITA_REQUEST,
    CREATE_CITA_SUCCESS,
    CREATE_CITA_FAILURE,
    UPDATE_CITA_REQUEST,
    UPDATE_CITA_SUCCESS,
    UPDATE_CITA_FAILURE,
    DELETE_CITA_REQUEST,
    DELETE_CITA_SUCCESS,
    DELETE_CITA_FAILURE,
    CREATE_CITA_WARNING
} from "../../../constants/citas/citas";
import { CitaDto } from "../../../types/citas/Citas";
import { RootState } from "../../store/store";
import fetchWithIP from "../utils/FechHeaders";
import { AnyAction } from "redux";
import { Alert, message } from "antd";

export const fetchCitasRequest = () => ({
    type: FETCH_CITAS_REQUEST
});

export const fetchCitasSuccess = (data: any) => ({
    type: FETCH_CITAS_SUCCESS,
    payload: data
});

export const fetchCitasFailure = (error: string) => ({
    type: FETCH_CITAS_FAILURE,
    payload: error
});


export const createCitaRequest = () => ({
    type: CREATE_CITA_REQUEST
});

export const createCitaSuccess = (data: any) => ({
    type: CREATE_CITA_SUCCESS,
    payload: data
});

export const createCitaFailure = (error: string) => ({
    type: CREATE_CITA_FAILURE,
    payload: error
});

export const updateCitaRequest = () => ({
    type: UPDATE_CITA_REQUEST
});

export const updateCitaSuccess = (data: any) => ({
    type: UPDATE_CITA_SUCCESS,
    payload: data
});

export const updateCitaFailure = (error: string) => ({
    type: UPDATE_CITA_FAILURE,
    payload: error
});

export const deleteCitaRequest = () => ({
    type: DELETE_CITA_REQUEST
});

export const deleteCitaSuccess = (citaId: string) => ({
    type: DELETE_CITA_SUCCESS,
    payload: citaId
});

export const deleteCitaFailure = (error: string) => ({
    type: DELETE_CITA_FAILURE,
    payload: error
});

export const createCitaWarning = (data: any) => ({
    type: CREATE_CITA_WARNING,
    payload: data
});


export const fetchCitas = (
    sucursalIds?: string[]
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
        dispatch(fetchCitasRequest());

        try {

            const response = await fetchWithIP(
                'citas/all',
                {
                    method: 'POST',
                },
                { sucursalIds }

            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Error al obtener las citas');
            }

            dispatch(fetchCitasSuccess(data));
            return data;
        } catch (error: any) {
            const errorMsg = error.message || 'Error desconocido al obtener las citas';
            dispatch(fetchCitasFailure(errorMsg));
            message.error(errorMsg);
            throw error;
        }
    };
};

export const createCita = (
    citaData: CitaDto
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => async (dispatch) => {
    dispatch(createCitaRequest());

    try {
        const token = localStorage.getItem('token');

        if (!token) {
            throw new Error('No se encontró token de autenticación');
        }

        const response = await fetchWithIP(
            'citas',
            {
                method: 'POST',
            },
            citaData
        );

        const data = await response.json();

        if (data.tipo === 'warning') {
            dispatch(createCitaWarning(data));
            return data;
        }

        if (!response.ok) {
            throw new Error(data.message || 'Error al crear la cita');
        }

        dispatch(createCitaSuccess(data));
        message.success('Cita creada exitosamente');
        return data;
    } catch (error: any) {
        const errorMsg = error.message || 'Error desconocido al crear el cita';
        dispatch(createCitaFailure(errorMsg));
        message.error(errorMsg);
        throw error;
    }
};

export const updateCita = (
    citaId: string,
    citaData: Partial<CitaDto>
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
        dispatch(updateCitaRequest());

        try {
            const token = localStorage.getItem('token');

            if (!token) {
                throw new Error('No se encontró token de autenticación');
            }

            const dataToSend = Object.fromEntries(
                Object.entries(citaData).filter(([_, v]) => v !== undefined && v !== null)
            );

            console.log('Datos a enviar al backend:', dataToSend);

            const response = await fetchWithIP(
                `citas/${citaId}`,
                {
                    method: 'PUT',
                },
                dataToSend
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Error al actualizar la cita');
            }

            dispatch(updateCitaSuccess(data));
            message.success('cita actualizado exitosamente');
            return data;
        } catch (error: any) {
            const errorMsg = error.message || 'Error desconocido al actualizar la cita';
            dispatch(updateCitaFailure(errorMsg));
            message.error(errorMsg);
            throw error;
        }
    };
};

export const deleteCita = (
    citaId: string
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
        dispatch(deleteCitaRequest());

        try {
            const token = localStorage.getItem('token');

            if (!token) {
                throw new Error('No se encontró token de autenticación');
            }

            const response = await fetchWithIP(
                `citas/${citaId}`,
                {
                    method: 'DELETE',
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Error al eliminar la Cita');
            }

            dispatch(deleteCitaSuccess(citaId));
            message.success('Cita eliminada exitosamente');
            return data;
        } catch (error: any) {
            const errorMsg = error.message || 'Error desconocido al eliminar la Cita';
            dispatch(deleteCitaFailure(errorMsg));
            message.error(errorMsg);
            throw error;
        }
    };
};
